import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Team } from '../../teams/team.interface';
import { TeamService } from './team.service';
const service = new TeamService();

export interface TeamState {
   teamsOverview?: ApiResource<Array<Team>>;
}

const TeamStore: Module<TeamState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_TEAMS_OVERVIEW(state, teamsOverview?: ApiResource<Array<Team>>) {
         state.teamsOverview = teamsOverview;
      },
      ADD_TEAM(state, team: Team) {
         state.teamsOverview?.data.push(team);
      },
      DELETE_TEAM(state, teamId: number) {
         const index = (state.teamsOverview?.data || []).findIndex((u) => u.id === teamId);
         if (index > -1) state.teamsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getTeams(context, payload: { userId: number; query?: LocationQuery }) {
         const response = await service.getTeams(payload.userId, payload.query);
         context.commit('SET_TEAMS_OVERVIEW', response);
         return response;
      },
      async addToTeams(context, payload: { userId: number; teams: Array<Team> }) {
         const response = await service.addUserTeams(payload.userId, payload.teams);
         response.forEach((team) => {
            context.commit('ADD_TEAM', team);
         });
         return response;
      },
      async removeFromTeams(context, payload: { userId: number; teams: Array<Team> }) {
         const response = await service.removeUserTeams(payload.userId, payload.teams);
         response.forEach((teamId) => {
            context.commit('DELETE_TEAM', teamId);
         });
         return response;
      },
   },
};

export default TeamStore;
